export default "__VITE_ASSET__BXW7QYw3__"